import { IKImage } from "imagekitio-next";
import React from "react";

const OffreImageWidth = 400;
const OffreImageHeigth = 400;

function OffreImage({ imageName, alt, className }) {
  return (
    <IKImage
      urlEndpoint={process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL}
      path={imageName || "default_image.jpg"}
      transformation={[{ crop: "maintain_ratio" }]}
      width={OffreImageWidth}
      height={OffreImageHeigth}
      alt={alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className={className}
    />
  );
}

export default OffreImage;
